import { useQuery } from '@tanstack/react-query'
import { apiClient } from '../api/axios-instance'

const isUuid = (val: string) => /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(val)

export const useDocumentUrl = (documentId?: string | null) => {
    return useQuery({
        queryKey: ['documentUrl', documentId],
        queryFn: async () => {
            if (!documentId) return null
            if (!isUuid(documentId)) return documentId // It's already a URL
            
            const res = await apiClient.get(`/documents/${documentId}/download-url`, { suppressErrorToast: true } as any)
            if (res.data?.success) {
                return res.data.data.download_url || res.data.data.cdn_url
            }
            return null
        },
        enabled: !!documentId,
        staleTime: 5 * 60 * 1000, // cache for 5 minutes
    })
}
